import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import PortfolioBanner from '../components/portfolio/PortfolioBanner'
import PortfolioHeader from '../components/portfolio/PortfolioHeader'
import { useLanguage } from '../contexts/LanguageContext'

const PortfolioPage = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
        return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>{t('seo.portfolioTitle')}</title>
        <meta name="description" content={t('seo.portfolioDescription')} />
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <div style={{ overflow: 'hidden', backgroundImage:'url("bg-img/MicrosoftTeams-image.webp")', width:'100%', backgroundAttachment:'fixed' }}>

        <PortfolioBanner/>
        <PortfolioHeader/>
    </div>
    </>
  )
}

export default PortfolioPage